import React, { useEffect, useState } from "react";
import getStorageData from "../../../Utils/getStorageData";
import Request from "../../../helpers/request";
import * as url from "../../../helpers/url_helper";
import { useSelector } from "react-redux";
import { GET_CHIP_STATUS } from "../../../helpers/socketEvent";
import { useSocket } from "../../../Utils/socket";
import { Card, CardBody, Row } from "reactstrap";
import SwitchData from "../ControlPanel/SwitchData";
import AirHomeLoader from "../../../components/Common/AirHomeLoader";

const Index = ({ room: roomSwitchDetail }: any) => {
  const data = useSelector((state: any) => state.APIResponse.chipData);

  const [loading, setLoading] = useState<boolean>(false);
  const [switchList, setSwitchList] = useState<any>([]);
  const [slaveData, setSlaveData] = useState<number[]>([]);

  const socket: any = useSocket();

  const switchListApiCall = () => {
    setLoading(true);
    Request.get(
      `${url.GET_SWITCH_LIST_URL}?premiseId=${
        getStorageData().selectedPremiseID
      }&roomId=${roomSwitchDetail.id}`
    )
      .then((res) => {
        var slave: any[] = [];
        const data = res.data.switches;

        for (let i = 0; i < data.length; i++) {
          const switchElement = data[i].chipSwitchId;
          slave.push(switchElement.slave);
        }
        var switches: any = [];
        for (let i = 0; i < data.length; i++) {
          const switchElement = data[i];

          // else {
          switches.push({
            switchItem: {
              ...switchElement,
              identifier: `${switchElement.chipSwitchId.slave}${switchElement.chipSwitchId.button}`,
            },
            switchDetail: {
              id: "",
              val: 0,
              dval: "XX",
              isNotificationSubscribed: false,
              displayName: "",
              roomName: "",
            },
            isClickable: false,
            isOnOff: "0",
            isMenually: false,
          });
        }
        {
          switches.length !== 0 && setSwitchList(switches);
        }
        setSlaveData(slave);
        removeDuplicateSlave(slave, data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const removeDuplicateSlave = (slave: number[], switches: any[]) => {
    let unique: any = [];
    slave.forEach((element: any) => {
      if (!unique.includes(element)) {
        unique.push(element);
      }
    });
    setSlaveData(unique);
  };

  useEffect(() => {
    getChipStatus();
  }, [slaveData]);

  const getChipStatus = async () => {
    socket.emit(GET_CHIP_STATUS, JSON.stringify(slaveData));
  };

  useEffect(() => {
    if (!loading && data.length > 0) {
      const updatedSwitchList = switchList.map((switchItem: any) => {
        const match = data.find(
          (item: any) => item.detail.id === switchItem.switchItem.chipId
        );

        if (match) {
          return {
            ...switchItem,
            isOnOff: match.detail.switches[
              switchItem.switchItem.chipSwitchId.button
            ].val
              ? match.detail.switches[switchItem.switchItem.chipSwitchId.button]
                  .val
              : "0",
            isClickable: match.slave && match.detail.isOnline ? true : false,
            switchDetail: {
              ...switchItem.switchDetail,
              val: match.detail.switches[
                switchItem.switchItem.chipSwitchId.button
              ].val,
              dval: match.detail.switches[
                switchItem.switchItem.chipSwitchId.button
              ].dval,
              isNotificationSubscribed:
                match.detail.switches[switchItem.switchItem.chipSwitchId.button]
                  .isNotificationSubscribed,
              displayName:
                match.detail.switches[switchItem.switchItem.chipSwitchId.button]
                  .displayName,
              roomName:
                match.detail.switches[switchItem.switchItem.chipSwitchId.button]
                  .roomName,
            },
          };
        } else {
          return switchItem;
        }
      });

      setSwitchList([...updatedSwitchList]);
    }
  }, [data, loading]);

  useEffect(() => {
    switchListApiCall();
    setSwitchList([]);
  }, [roomSwitchDetail]);
  return (
    <>
      {loading && <AirHomeLoader />}
      <Card
        style={{
          marginTop: 100,
          marginLeft: 30,
          marginRight: 30,
          marginBottom: 0,
          backgroundColor: "#0d1b2a",
        }}
      >
        <CardBody>
          <div
            className="mt-20"
            style={{
              pointerEvents: !roomSwitchDetail?.canControl ? "none" : "auto",
              cursor: !roomSwitchDetail?.canControl ? "not-allowed" : "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexDirection: "row",
                width: "100% !important",
              }}
            >
              <p style={{ cursor: "pointer" }}></p>
              <span style={{ width: "40% !important" }}>
                <p style={{ fontSize: 24, color: "#fff" }}>
                  {" "}
                  Room Name: {roomSwitchDetail.name}
                </p>
              </span>
              <span style={{ width: "40% !important" }}>
                {roomSwitchDetail?.canControl ? (
                  <></>
                ) : (
                  <i className="bx bx-lock" style={{ fontSize: 30 }}></i>
                )}
              </span>
            </div>

            <Row>
              {switchList.length ? (
                switchList.map((item: any, index: any) => {
                  return (
                    <React.Fragment key={index}>
                      <SwitchData
                        switchData={item}
                        getChipStatus={() => getChipStatus()}
                      />
                    </React.Fragment>
                  );
                })
              ) : (
                <div style={{ height: "30vh", textAlign: "center" }}>
                  <h4 style={{ color: "#667085" }}>No switchs Available</h4>
                </div>
              )}
            </Row>
          </div>
        </CardBody>
      </Card>
    </>
  );
};

export default Index;
